import { DashMenuOptionsProps } from '@/components/DashMenu/interfaces';
import config from '@/Constants';
import AxiosHelper from '@shared/infra/protocols/http/AxiosHelper';

async function fetchDashMenu(
  superGroupId: string,
): Promise<DashMenuOptionsProps[]> {
  const urlAux = config.DASHBOARD_MOCK ? config.DASHBOARD_MOCK_URL : '';

  const url = `${urlAux}get_dashboards?super_group_id=${superGroupId}`;

  const response = await AxiosHelper.get({ url });
  const data: DashMenuOptionsProps[] = response.body;
  return data;
}

export default fetchDashMenu;
